import m from "../../../../geodata/es2015/region/usa/iaHigh";
window.am4geodata_region_usa_iaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/iaHigh.js
// module id = null
// module chunks = 